export enum FormControlName {
  PadraoEntrada = 'padraoEntrada',
  MediaConsumo = 'mediaConsumo',
  PrecoKWH = 'precoKWH',
  Estado = 'estado',
  Cidade = 'cidade',
  Nome = 'nome',
  Telefone = 'telefone',
  Email = 'email',
}

export interface SelectInputOption {
  label: string;
  value: string;
}
